import { NOT_AVAILABLE, RESUBMISSION_LABELS } from "../../utils/messages";
import { DIVERGENCE_STATUS_VARIANTS, STATUS_VARIANTS } from "../../utils/constants";
import { statusLabelOf } from "../../utils/status-options";
import { StatusVariant } from "../../types";
import { StatusBadge } from "./status-badge";

const VARIANT_BY_STATUS: Readonly<Record<string, StatusVariant>> = DIVERGENCE_STATUS_VARIANTS;

interface StatusWithResubmissionProps {
  status: string | null | undefined;
  resubmitted: boolean;
  resubmissionTestId: string;
}

export function StatusWithResubmission({
  status,
  resubmitted,
  resubmissionTestId,
}: StatusWithResubmissionProps): JSX.Element {
  return (
    <div className="flex flex-wrap items-center gap-1">
      <StatusBadge
        variant={(status && VARIANT_BY_STATUS[status]) || STATUS_VARIANTS.DEFAULT}
      >
        {status ? statusLabelOf(status) : NOT_AVAILABLE}
      </StatusBadge>

      {resubmitted && (
        <StatusBadge
          variant={STATUS_VARIANTS.RESUBMISSION}
          data-testid={resubmissionTestId}
          title={RESUBMISSION_LABELS.BADGE_TITLE}
        >
          {RESUBMISSION_LABELS.BADGE}
        </StatusBadge>
      )}
    </div>
  );
}
